import { env } from '../env';

var location = function location() {
  return typeof env() !== 'undefined' && env().location;
};

export default {
  getHost: function getHost() {
    return location() && env().location.host;
  },
  isFedopsDev: function isFedopsDev() {
    var q = (location() || {}).search || '';
    return q.indexOf("fedops=dev") > -1;
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/fedops-logger/dist/es/src/global-app-data/location.js
// module id = 245
// module chunks = 0 1